<template>
	<div class="header-template">
		<div class="header-box">
			<div class="logo-box" @click="logo_box()">
				<img class="logo-img" src="../../assets/logo/TOZO_logo_pc.png" alt="TOZO Official logo"/>
				<!-- <img :src="logoUrl"/> -->
			</div>
			<div class="menu-box">
				<MenuPc></MenuPc>
			</div>
			<div class="right-box">
				<div class="language_box">
					<language></language>
				</div>
				<div class="userData-box" v-if="userDataShow" @mouseenter="showDropdown = true" @mouseleave="showDropdown = false">
					<div class="userData">
						<div class="avatar" v-if="userData.user_id" @click.stop="check_information(userData)">
						 	<img v-if="userData.avatar && userData.avatar != ''" :src="userData.avatar" alt="TOZO User profile picture"/>
						 	<i v-else class="el-icon-s-custom"></i>
						</div>
						<div class="avatar" v-else @click.stop="login_in()">
							<i class="el-icon-s-custom"></i>
						</div>
					</div>
					<div class="dropdownBox" v-show="showDropdown && userData.user_id">
						<div class="dropdown" @click.stop="check_information(userData)">{{ $t('nav_box.Account.My_account') }}</div>
						<div class="dropdown" @click.stop="log_out()">{{ $t('nav_box.Account.Sign_out') }}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MenuPc from './MenuPc.vue'
import language from './language.vue'

export default {
	name: 'header-nav-pc',
	components: { MenuPc, language },

	// props: {
	// 	Post_List: {
	// 		type: Array,
	// 		default: []
	// 	},
	// },
	data() {
		return {
			logoUrl: "https://www.tozostore.com/cdn/shop/files/TOZO_-01_200x.png?v=1683880396",
			userData: this.$store.state.userinfo,
			showDropdown: false,
			userDataShow: true
		}
	},
	
	// 监听
	watch: {
		"$store.state.userinfo": {
			handler: function (newValue, oldValue) {
				this.userData = this.$store.state.userinfo
			},
			deep: true
		},
	},
	
	// beforeCreate() {
		
	// }
	
  created () {
	  
  },
  
  mounted() {
	  // this.list = this.Post_List
	  // let that = this
	  // setTimeout(()=>{
			// that.userData = that.$store.state.userinfo,
			// that.userDataShow = true
	  // }, 2000)
  },
  
  methods:{
	//查看 粉丝或关注人信息
	check_information(item){
		console.log(item)
		console.log(this.$route.name)
		if(this.$route.name == 'user-profile'){ return }
		this.$router.push({
		   name: "user-profile",
		   params: {}
		})
	},
	
	logo_box(){
		let language = this.$language == "" || this.$language == "en" ? "" : `/${this.$language}`
		console.log(language)
		window.open(`https://www.tozostore.com${language}`, '_blank')
	},
	
	login_in(){
		console.log('login_in')
		let host = process.env.VUE_APP_API_URL_LOGIN
		let url = `${host}&locale=${this.$language}`
		window.location.href = url;
	},
	
	log_out() {
		let decodedCookies = {};
		let cookieValue = document.cookie;
		let domain = process.env.VUE_APP_API_URL_domain
	  if(cookieValue && cookieValue.length != 0){
	    cookieValue.split(';').forEach(cookie => {
	      let parts = cookie.split('=');
	      let key = decodeURIComponent(parts[0].trim()); //decodeURIComponent反转译
	      let value = decodeURIComponent(parts[1]);
	      decodedCookies[key] = value;
			if(key == 'DIV_authentication' || key == 'token' || key == 'login_token'){
				let toekn = ''
				let maxAge = new Date()
				if(key == 'DIV_authentication'){
				  document.cookie = `DIV_authentication=${toekn};domain=${domain};max-age=${maxAge};path=/`
				  console.log(decodedCookies.DIV_authentication)
				}
				if(key == 'token'){
				  document.cookie = `token=${toekn};domain=${domain};max-age=${maxAge};path=/`
				  console.log(decodedCookies.token)
				}
				if(key == 'login_token'){
				  document.cookie = `login_token=${toekn};domain=${domain};max-age=${maxAge};path=/`
				  console.log(decodedCookies.login_token)
				}
			}
	    });
	    console.log(decodedCookies.DIV_authentication)
	    console.log(domain)
	  }
		console.log(document.cookie)
		this.$cookie.delete('login_token') //社区接口的token
		this.$cookie.delete('login_token_expire') //社区接口的token的过期时间
		this.$cookie.delete('token') //官网接口的token
		this.$cookie.delete('DIV_authentication') //获取token的key
		this.$cookie.delete('DIV_authentication_expire') //获取token的key的过期时间
		this.$cookie.delete('user')
		this.$store.dispatch('signOut', [this, ''])
		setTimeout(()=>{
			this.$router.push({name: "home"})
			location.reload()
		}, 1500)
	  // if(this.$route.name == 'Checkout'){
	  //   this.$router.push({name: "index"})
	  // }else if(this.$route.name == 'userinfo'){
	  //   this.$router.push({name: "index"})
	  // }else{
	  //   location.reload()
	  // }
	},
	
	//查看详情
	view_details(item){
		console.log(item)
	},
	
  }
}
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.header-template{
		width: 100%;
		display: flex;
		justify-content: center;
		padding: 0%;
	}
	.header-box{
		width: 100%;
		max-width: 1280px;
		padding: 0px 0px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.logo-box{
		max-width: 120px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	.logo-img{
		max-width: 120px;
		width: 100%;
	}
	.menu-box{
		margin: 0px 10px;
		width: calc(100% - 120px - 50px - 20px);
	}
	.right-box{
		display: flex;
		min-width: 46px;
		/* border: 1px #f5f5f5 solid; */
		.userData-box {
		  position: relative;
		}
		
		.dropdownBox {
		   position: absolute;
		   top: 100%;
		   right: 0;
		   background-color: #fff;
		   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		   z-index: 1;
			width: 190px;
			padding: 10px 0px;
         border-radius: 0px 0px 8px 8px;
		}
		
		.dropdown {
		   padding: 8px 10px;
		   cursor: pointer;
		}
		
		.dropdown:hover {
		  background-color: #f0f0f0;
		}
	}
	.language_box{
		width: 100px;
		display: flex;
		align-items: center;
		margin-right: 10px;
	}
	.avatar{
		border: 1px #f5f5f5 solid;
		width: 46px;
		height: 46px;
		cursor: pointer;
		overflow: hidden;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		i{
			font-size: 27px;
		}
		img{
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}
	
	@media screen and (min-width: 1024px) and (max-width: 1320px) {
	  .header-box{
			padding: 0px 20px;
	  }
	}
	@media screen and (max-width: 1024px) {
	  .header-box{
			padding: 0px 0px;
	  }
	}
</style>
